<div class="row mb-3 align-items-center">
    @if (model.customerPurchaseOrderNumber) {
        <label
            class="col-lg-3 col-md-8 col-form-label text-start text-lg-end"
            translate="CONFIRMATION_AKZ_LABEL"
        ></label>
    }
    @if (model.customerPurchaseOrderNumber) {
        <div class="col-lg-3 col-md-8 mb-lg-0 mb-3">
            <pace-core-text-input
                [(model)]="model.customerPurchaseOrderNumber"
                [parentForm]="parentForm"
            ></pace-core-text-input>
        </div>
    }
    <label
        class="col-lg-3 col-md-8 col-form-label text-start text-lg-end"
        translate="CONFIRMATION_LANGUAGE_LABEL"
    ></label>
    <div class="col-lg-3 col-md-8">{{ model.serviceReportLanguage.value }}</div>
</div>
@if (model.reportVisibilityToCustomer) {
    <hr class="separator" />
    <div class="row mb-3">
        <label
            class="col-lg-3 col-md-4 col-form-label text-start"
            translate="CONFIRMATION_SERVICE_REPORT_VISIBILITY_LABEL"
        ></label>
        <div class="col-md-4">
            <pace-core-radio-input
                [(model)]="model.reportVisibilityToCustomer"
                [parentForm]="parentForm"
                id="reportVisibilityToCustomer"
                (valueChange)="setCrmLongTextNOSRSetValue()"
            >
            </pace-core-radio-input>
        </div>
    </div>
}
<hr class="separator" />
<label
    class="col-form-label text-start"
    for="recipients"
    translate="CONFIRMATION_SERVICE_REPORT_RECIPIENTS_LABEL"
></label>
<div class="row mb-3 justify-content-center">
    <div class="col-lg-6 col-md-8 col-12">
        <pace-recipient-list
            id="recipients"
            [model]="model.existingRecipients"
            [displaySubmitButton]="enableDataMaintenanceEnhancement"
            [notificationId]="this.model.notificationModel"
            [parentForm]="parentForm"
        ></pace-recipient-list>
    </div>
</div>
